import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
export function Hero() {
  return <section className="py-8 sm:py-10 px-4 bg-brand-cream" data-id="element-102">
      <div className="max-w-3xl mx-auto text-center" data-id="element-103">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-petrol/10 border border-brand-petrol/20 text-brand-petrol font-semibold text-xs sm:text-sm mb-4" data-id="element-104">
          <span data-id="element-105">⚡</span>
          <span data-id="element-106">VALIDATED COACHING SYSTEM</span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-brand-graphite leading-tight mb-3" data-id="element-107">
          The Complete Operating System for Functional Training Coaches
        </h1>

        <p className="text-base sm:text-lg text-brand-graphite/80 leading-relaxed mb-4 max-w-2xl mx-auto" data-id="element-108">
          Stop building sessions from scratch, reclaim your time, and elevate
          your coaching — without the exhaustion of programming everything
          manually.
        </p>

        <div className="inline-block bg-brand-gold/20 border-2 border-brand-gold px-4 py-1.5 rounded-lg mb-5" data-id="element-109">
          <p className="font-bold text-brand-petrol text-base sm:text-lg" data-id="element-110">
            FUNCTIONAL PRO™ 6-in-1 Complete System
          </p>
        </div>

        <div className="mb-5" data-id="element-111">
          <a href="#pricing" className="block cursor-pointer" data-id="element-112">
            <img src="https://cdn.magicpatterns.com/uploads/xri7Vdckrt4sTKeQinh8Pe/ChatGPT-Image-12-jun-2026_-22_58_43.webp" alt="FUNCTIONAL PRO 6-in-1 Complete System" className="w-full h-auto object-contain max-w-md sm:max-w-lg mx-auto hover:scale-105 transition-transform duration-300" data-id="element-113" />
          </a>
        </div>

        <div className="mb-4" data-id="element-114">
          <CTAButton className="max-w-md mx-auto" data-id="element-115">
            🚀 YES, I WANT MY SYSTEM NOW
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-brand-graphite/70" data-id="element-116">
          <div className="flex items-center gap-1" data-id="element-117">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-118" />
            <span className="font-semibold" data-id="element-119">
              4.9/5 — Verified Professional Reviews
            </span>
          </div>
          <span className="hidden sm:inline" data-id="element-120">•</span>
          <div className="flex items-center gap-1" data-id="element-121">
            <Shield className="w-4 h-4 text-brand-petrol" data-id="element-122" />
            <span className="font-semibold" data-id="element-123">7-Day Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}